import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { isMobile } from 'react-device-detect';

const Layout = props => {

	return (
		<main >
			<div style={{ width: '100%', height: 'inherit'}}>
				{props.children}
			</div>
		</main>
	);
};

export const Divider = props => <div style={{ display: 'flex', width: 'inherit', height: 'inherit'}}>{props.children}</div>;

export const Top = () => {
	
	return (
		<div>
			{/* {authenticated && showMessage?.show === true ? <MessageBar /> : authenticated && showMenu && <MenuBar userLogoutHandler={userLogoutHandler} isAuthenticated={authenticated && onBoardingCompleted} />} */}
		</div>
	);
};
export const Left = props => {
	
	return (
		<div
			style={{
				backgroundColor: 'rgb(246,244,236)',
				width: isMobile ? '0' : '12%',
				padding: '100px 10px 20px 10px',
				minWidth: '160px',
			}}
		>
			{props.children}
		</div>
	);
};

export const Right = props => {
	return <div style={{ width: '100%', minHeight: '90vh' }}>{props.children}</div>;
};

export default Layout;
